module.exports = __webpack_public_path__ + "img/eva_simple.98b03c0e.png";